import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ColDef, GridOptions } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JSIGNALBUTTON } from 'src/app/shared/common/JsignalButtons';
import { AlertRuleService } from 'src/app/shared/services/alert-rule.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { constants } from "src/app/shared/common/contants";
import { Router } from '@angular/router';




@Component({
    selector: 'app-my-tasks',
    templateUrl: './my-tasks.component.html',
    styleUrls: ['./my-tasks.component.scss'],
    standalone: false
})
export class MyTasksComponent implements OnInit {

  gridOptions!: GridOptions;
  columnDefs!: ColDef[];
  defaultColDef: ColDef = {};
  rowData: any[] = [];

  overdueCount = 0;
  todayCount = 0;
  upcomingCount = 0;
  totalCount = 0;
  Completed = 0;

  activeFilter = 'all';
  components: any;
  rowClassRules: any;
  getRowStyle: any;
  gridApi: any;
 clickTimeout: any = null;
isSidenavOpen=true;
  selectedProductDetails:any=null;
  constructor(
      private snackBar: MatSnackBar,
      private spinner: NgxUiLoaderService,
      private jsignalsService: JsignalService,
      private localStorageSettings: LocalStorageSettingsService,
      private fb: FormBuilder,
      private dialog: MatDialog,
      private constants: constants,
      private router: Router,
    ) {
      this.components = {
        jsignalButton: JSIGNALBUTTON,
      };
    }

  ngOnInit(): void {
    this.initColumns();
    this.loadTasks();
    this.updateStats(this.rowData);
  }

  initColumns(): void {
    this.columnDefs = [
  // {
  //   headerName: "Task Subtype",
  //   field: "taskSubtype",
  //    filter: "agTextColumnFilter",
  //   width: 180,
  //   ...this.jsignalsService.autoTooltip("Task Subtype")
  // },
    {
    headerName: "Task Type",
    field: "taskType",
     filter: "agTextColumnFilter",
    width: 250,
    ...this.jsignalsService.autoTooltip("Task Type"),
   
  },
  {
    headerName: "Task Title",
    field: "title",
     filter: "agTextColumnFilter",
    cellRenderer: 'jsignalButton',   
    cellRendererParams: {
      normalLink: (params: any) => this.onTaskTitleClick(params)
    },
    width: 300,
    ...this.jsignalsService.autoTooltip("Task Title")
  },
  {
    headerName: "Product Name",
    field: "productName",
     filter: "agTextColumnFilter",
    width: 250,
    ...this.jsignalsService.autoTooltip("Product Name")
  },
  {
    headerName: "State",
    field: "state",
     filter: "agTextColumnFilter",
    width: 250,
    ...this.jsignalsService.autoTooltip("State"),
          cellRenderer: (params: any) => {
        const state = params.data.state; // display text
        let badgeClass = "";

        // Map stateCode to badge classes
        switch (state) {
          case "In Review":
            badgeClass = "state-badge review";
            break;
          case "In Approval":
            badgeClass = "state-badge approval";
            break;
          case "Approved":
            badgeClass = "state-badge approved";
            break;
          case "Completed":
            badgeClass = "state-badge approved";
            break;  
          case "Superseded":
            badgeClass = "state-badge superseded";
            break;
          default:
            badgeClass = "state-badge default";
        }

        return `
      <span class="${badgeClass}">
        <span class="dot"></span>${state}
      </span>`;
      },
  },
  // {
  //   headerName: "Assigned By",
  //   field: "assignedBy",
  //    filter: "agTextColumnFilter",
  //   width: 160,
  //   ...this.jsignalsService.autoTooltip("Assigned By")
  // },
  {
    headerName: "Start Date",
    field: "startDate",
     filter: "agTextColumnFilter",
    width: 180,
    ...this.jsignalsService.autoTooltip("Start Date"),
   
  },
    {
    headerName: "Due Date",
    field: "dueDate",
     filter: "agTextColumnFilter",
    width: 200,
    
    ...this.jsignalsService.autoTooltip("Due Date"),
   
    cellRenderer: params => {
    const status = params.data.dueStatus;
    const date = params.value;

    if (status === 'overdue') {
      return `<span style="color:#b00020;font-weight:600;">${date}</span>`;
    }
    console.log(params.data.isOverdue);

    return date;
  }
  },
    ];
      this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
       rowClassRules: {
    'row-overdue': params => params.data?.isOverdue === true
  }
    };

     // if the record has status==no , row color will change
    // this.rowClassRules = {
    //   sick: function (params) {
    //     var numSickDays = params.node.data.status;
    //     return numSickDays === "No" || numSickDays === null;
    //   }
    // };
    // this.getRowStyle = (params: any) => {
    //   console.log(params);
    //   console.log(params.data.status);
    //   if (params.data.status === "No") {
    //     return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
    //   }
    //   // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    // };
  }

// loadTasks(): void {
//   const userId = this.localStorageSettings.getSettings("UserId");
//     if (!userId) {
//     console.error('UserId not found in localStorage');
//     return;
//   }
//   const rawData = [
//     {
//       id: 'PS-36',
//       taskType: 'Product Safety Strategy',
//       productName: 'Atezolizumab',
//       title: 'Review :- Product Strategy: Bevacizumab',
//       dueDate: '2026-02-03',
//       state: 'In Review',
//       assignedBy: 'System',
//       assignedOn: '2026-02-03'
//     },
//     {
//       id: 'PS-22',
//       taskType: 'Product Safety Strategy',
//       title: 'Approve :- Product Strategy: Pembrolizumab',
//       productName: 'Pembrolizumab',
//       dueDate: '2026-12-18',
//       state: 'In Approval',
//       assignedBy: 'Product Owner',
//       assignedOn: '2026-12-18'
//     },
//     {
//       id: 'PS-22',
//       taskType: 'Review Activities',
//       productName: 'Pembrolizumab',
//       title: 'Review :- Fatal Case Review',
//       dueDate: '2026-02-01',
//       state: 'completed',
//       assignedBy: 'Product Owner',
//       assignedOn: '2026-12-18'
//     }
//   ];

//   this.rowData = rawData.map(task => {
//     const dueStatus = this.getDueStatus(task.dueDate);

//     return {
//       ...task,
//       dueStatus,                // overdue | today | upcoming
//       isOverdue: dueStatus === 'overdue'
//     };
//   });

//   this.gridApi?.setGridOption('rowData', this.rowData);
//   this.updateStats(this.rowData);
//   this.activeFilter = null;
  
// }

loadTasks(): void {
  const userId = localStorage.getItem('UserId');

  if (!userId) {
    console.error('UserId not found in localStorage');
    return;
  }

  this.spinner.start();
  this.jsignalsService.getAllTaskOfLoggedInUser(userId).subscribe({
    next: (response) => {

      if(response.error === true){
        console.log(response);
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});
        return;  
      }

      const rawData = response || [];

      this.rowData = rawData.map(task => {
          const isCompleted = task.status === 'Completed';

        const dueStatus = isCompleted 
          ? null 
          : this.getDueStatus(task.dueDate);

        return {
          id: task.referenceId,                 // from API
          taskType: task.taskType,
          productName: task.productName,
          title: task.taskTitle,
          dueDate: task.dueDate,
          state: task.status,
          assignedBy: task.createdBy,           //  from API
          startDate: task.startDate,         //  from API
          urlPath: task.urlPath,

          // UI fields
          dueStatus,
          isOverdue: dueStatus === 'overdue'
        };
      });

      this.gridApi?.setGridOption('rowData', this.rowData);
      this.updateStats(this.rowData);
      this.activeFilter = null;
      this.spinner.stop();
    },

    error: (err) => {
      console.error('Error loading tasks:', err);
      this.spinner.stop();
    }
  });
}



applyFilter(type: string): void {
  this.activeFilter = type;

  let filtered = this.rowData;

  if (type !== 'all') {
    filtered = this.rowData.filter(t => {
      if (type === 'completed') {
        return t.state === 'Completed'; // correct
      }

      if (type === 'overdue' || type === 'today' || type === 'upcoming') {
        return t.dueStatus === type;
      }

      return t.taskType === type;
    });
  }

  this.gridApi?.setGridOption('rowData', filtered);
}

updateStats(data: any[]): void {
  this.overdueCount = data.filter(t => t.dueStatus === 'overdue').length;
  this.todayCount = data.filter(t => t.dueStatus === 'today').length;
  this.upcomingCount = data.filter(t => t.dueStatus === 'upcoming').length;
  this.totalCount = data.length;
   this.Completed = data.filter(t => t.state === 'Completed').length;
}


  getDueStatus(date: string): 'overdue' | 'today' | 'upcoming' {
    const due = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);

    if (due < today) return 'overdue';
    if (due.getTime() === today.getTime()) return 'today';
    return 'upcoming';
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }

  getTaskTypeLabel(type: string): string {
    return {
      review: 'Review',
      approval: 'Approval',
      signoff: 'Sign-off',
      feedback: 'Feedback',
      'action-item': 'Action Item'
    }[type] || type;
  }

  getDueStatusLabel(status: string): string {
    return {
      overdue: 'Overdue',
      today: 'Due Today',
      upcoming: 'Upcoming'
    }[status]!;
  }

   onGridReady(params: any) {
    this.gridApi = params.api;
  }

  onRefresh(){
    this.loadTasks();
  }

   onDownload() {
    console.log("Download clicked");
    // export logic (CSV / Excel)

    this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "MyTasks.csv",
      });

      this.spinner.stop();
    }, 500);
  }

  /** Handle click vs double-click */
  onCardClick(status: string) {
    // debugger;
    if (this.clickTimeout) {
      // Double-click detected → clear filter
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
      this.clearFilter();
      return;
    }

    // Single-click detected (wait to confirm it's not a double)
    this.clickTimeout = setTimeout(() => {
      this.clickTimeout = null;
      this.applyFilter(status);
    }, 250); // 250ms threshold for double-click
  }

    clearFilter() {
    if (!this.gridApi) return;

    this.activeFilter = null;
    this.gridApi.setFilterModel(null);
    this.gridApi.onFilterChanged();
    this.gridApi.setGridOption('rowData', this.rowData);
    // this.updateStats(this.rowData);
  }


onTaskTitleClick(params: any) {
  const row = params.rowData;

  const url = `/user/Menubar/${row.urlPath}`;

  window.open(url, '_blank');
}


}
